import './NoPartnerPage.css';

export default function NoPartnerPage() {
  return (
    <div className="np-root">
      <div className="np-card">
        <div className="np-icon" aria-hidden>📷</div>
        <h2 className="np-title">No Passenger Found</h2>
        <p className="np-sub">Please rescan the QR code provided at your hotel to continue.</p>
      </div>
    </div>
  );
}